<!--
  我的菜单（/myNav）
  新版：allMenusNew（分组 + 「我的 / 全部」切换）；旧版：allMenusOld（三列卡片）
-->
<template>
  <PageHeaderLayout>
    <div class='main-page-content'>
      <div class='my-nav-page'>
        <!-- 页头：侧边栏开关 + 标题说明 + 新旧版切换（滚动时吸顶） -->
        <div class='my-nav-page__header'>
          <div class='my-nav-page__header-main'>
            <i class='my-nav-page__toggle'
               :title='`${isCollapse ? "展开侧边栏" : "隐藏侧边栏"}`'
               :class="[isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold']"
               @click='showSidebar'></i>
            <div class='my-nav-page__title-box'>
              <div class='my-nav-page__title'>我的菜单</div>
              <div class='my-nav-page__desc'>按分组查看系统菜单，支持「我的 / 全部」切换</div>
            </div>
          </div>
        </div>

        <!-- 菜单内容（新版 / 旧版） -->
        <div class='my-nav-page__body'>
          <allMenusNew></allMenusNew>
        </div>
      </div>
    </div>
  </PageHeaderLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

import allMenusOld from '@/pages/user/components/allMenusOld.vue'
import allMenusNew from '@/pages/user/components/allMenusNew.vue'

export default {
  name: 'UserComponentsMyNav',
  components: { allMenusOld, allMenusNew, PageHeaderLayout },
  computed: {
    ...mapGetters(['routePath', 'userPermissions', 'isCollapse'])
  },
  data() {
    return {
      navType: 'new'
    }
  },
  methods: {
    showSidebar() {
      //
      this.$store.commit('changeCollapse')
    },
    handleNavType() {
      this.navType = this.navType === 'old' ? 'new' : 'old'
      localStorage.setItem('allNavType', this.navType)

    },
    keyEvent(event) {
      // console.log('key:', event.key)
      if (event.key === 'ArrowRight') {
        if (this.isCollapse) {
          event.preventDefault()
          this.$store.commit('changeCollapse')
        }
      } else if (event.key === 'ArrowLeft') {
        if (!this.isCollapse) {
          event.preventDefault()
          this.$store.commit('changeCollapse')
        }
      }
    }
  },
  mounted() {
    // const navType = localStorage.getItem('allNavType')
    // if (navType) {
    //   this.navType = navType
    // }
    //绑定键盘事件-调出侧边菜单
    document.body.addEventListener('keyup', this.keyEvent)
  },
  destroyed() {
    document.body.removeEventListener('keyup', this.keyEvent)
  }
}
</script>
<style lang='scss' scoped>
.my-nav-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  box-sizing: border-box;

  &__header {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding: 12px 16px;
    background: #fff;
    border-bottom: 1px solid $--border-Lighter-color;
  }

  &__header-main {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  &__toggle {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    margin-right: 10px;
    border-radius: 6px;
    color: $--color-text-regular;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    transition: color .2s ease, background-color .2s ease;

    &:hover {
      color: #ff3176;
      background: #fff0f6;
    }
  }

  &__title-box {
    min-width: 0;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: $--color-text-primary;
  }

  &__desc {
    font-size: 12px;
    line-height: 18px;
    color: $--color-text-secondary;
  }

  &__switch {
    flex-shrink: 0;
    font-size: 13px;

    i {
      margin-right: 4px;
    }
  }

  &__body {
    flex: 1;
    padding: 12px 16px 16px;
    box-sizing: border-box;
  }
}

// 覆盖 BasicLayout 给 .main-page-content 直接子元素注入的白底与内边距，由页面自行控制留白
.main-page-content .my-nav-page {
  padding: 0;
  background: transparent;
}
</style>
